import { MapPageListing } from '@zoocasa/go-search';

export type ListingCardMapData = {
  id: number;
  imageUrl: string | null;
  imageDesc: string | null;
  isImageReady: boolean;
  addressPathWithFallback: string;
  isCrea: boolean;
  isItsoVow: boolean;
  isPillar9Vow: boolean;
  isRebgvVow: boolean;
  city: string | null;
  province: string | null;
  isPrivate: boolean;
  position: {
    latitude: number;
    longitude: number;
  } | null;
  getStreet(isAuthenticated: boolean): string | null;
  providerId: number;
  isSignInAndTermsOfUseRequired: boolean;
  mlsNum: string | null;
  brokerage: string | null;
  bedrooms: number;
  bathrooms: number;
  sqftLabel: string;

  shouldScramblePrice: boolean;
};

export const LOGIN_REQUIRED_TYPE = 'login-required';
export const TERMS_OF_USE_REQUIRED_TYPE = 'terms-of-use-required';
export const LISTING_TYPE = 'listing';
export type MapListingCardType = typeof LOGIN_REQUIRED_TYPE | typeof TERMS_OF_USE_REQUIRED_TYPE | typeof LISTING_TYPE;

export type CompliancyDelegateType = {
  getMapListingCardType(listing: MapPageListing): MapListingCardType;
  mustShowProviderLogo(listing: MapPageListing): boolean;
  shouldOpenAsModal(listing: MapPageListing): boolean;
  hideSquareFootage(listing: MapPageListing): boolean;
};